import { EmptyState } from 'construct-ui';
import userMapModel from '../../../../models/user/user-map.model';
import ViewBase from '../../../view-base.view';
import UserDetailsCountryMapCard from './user-details-country-map.card';

export default function UserDetailsCountryMapView() {
  ViewBase.call(this);
  let _countryList = [];

  const setCountryList = (userId) => {
    this.showLoading();
    userMapModel.getByUser(
      (result) => {
        this.hideLoading();
        _countryList = result?.map(c => ({ code: c.countryCode, name: c.mapData })) ?? [];
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      }, 'all', 'country', userId);
  }

  return {
    oninit: ({ attrs }) => {
      setCountryList(attrs.userId);
    },
    view: ({ attrs }) => {
      return [
        m(".card.mb-3",
          m(".card-body.py-4",
            m('.row.justify-content-center',
              m('.col-md-12',
                m('form',
                  m('.row.mb-3.small',
                    m('h3', this.getText("LT00000267", "Country Map Data"))
                  ),
                  _countryList.map(c => m(UserDetailsCountryMapCard, { userId: attrs.userId, country: c }))
                ),
                _.isEmpty(_countryList) &&
                m('.position-relative.p-5.text-center',
                  m(EmptyState, {
                    header: [
                      m('p', this.getText('LT00008095', 'This user has no mapped country.')),
                    ]
                  })
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
